export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto bg-background-900 rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-4">
                移动阅读
              </h2>
              <p className="text-sm text-white/65 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                刃牙漫画适配移动端阅读体验。下拉式畅享全系列，地铁上、午休时、睡前片刻，随时随地进入刃牙的热血格斗世界。刃牙漫画在线看，手机电脑无缝切换。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="cursor-pointer px-6 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors flex items-center gap-2 whitespace-nowrap">
                  <i className="ri-android-line"></i>
                  <span>Android 版本</span>
                </div>
                <div className="cursor-pointer px-6 py-3 rounded-full border border-white/20 text-white font-medium text-sm hover:bg-white/10 transition-colors flex items-center gap-2 whitespace-nowrap">
                  <i className="ri-apple-line"></i>
                  <span>iOS 版本</span>
                </div>
              </div>
            </div>
            <div className="flex-1 flex justify-center p-6 md:p-0">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20manga%20reading%20app%20interface%20with%20dark%20theme%2C%20warm%20crimson%20and%20amber%20accents%2C%20clean%20modern%20UI%2C%20japanese%20manga%20style%20aesthetic%2C%20minimal%20design%2C%20on%20dark%20gradient%20background%2C%20professional%20product%20photography&width=500&height=700&seq=app-baki-mockup&orientation=portrait"
                alt="刃牙漫画移动端阅读界面"
                className="max-h-[400px] object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}